import { useEffect, useRef } from "react";
import { useQuery } from "@tanstack/react-query";
import { Badge } from "@mui/material";

import { getUnreadCount } from "../../Messages/apiService";

const notify = (delta) => {
  if (typeof Notification === "undefined" || Notification.permission !== "granted") return;

  const body = delta === 1 ? "1 new message" : `${delta} new messages`;

  try {
    const n = new Notification("New message", {
      body,
      icon: "/logo192.png",
      tag: "novosalon-unread",   // replaces rather than stacks
      renotify: true
    });
    n.onclick = () => {
      window.focus();
      window.location.href = "/messages";
      n.close();
    };
  } catch {
    // Android Chrome throws here — constructor is unavailable, needs the SW path
  }
};

const UnreadMessages = () => {
  const prevCount = useRef(null);

  const { data } = useQuery({
    queryKey: ["messages", "unread"],
    queryFn: getUnreadCount,
    refetchInterval: 150000 // 2.5 minutes
  });

  const count = data?.unread_threads ?? 0;

  useEffect(() => {
    if (data === undefined) return;              // nothing fetched yet

    if (prevCount.current === null) {            // first successful load — seed only
      prevCount.current = count;
      return;
    }

    if (count > prevCount.current && document.visibilityState !== "visible") {
      notify(count - prevCount.current);
    }

    prevCount.current = count;
  }, [data, count]);

  // useEffect(() => {
  //   if (typeof Notification !== "undefined" && Notification.permission === "default") {
  //     Notification.requestPermission();
  //   }
  // }, []);

  return count > 0 ? (
    <Badge
      badgeContent={count}
      color="secondary"
      sx={{ position: "absolute", top: "50%", transform: "translateY(-50%)", right: "1.5rem" }}
    />
  ) : null;
};

export default UnreadMessages;